import React from 'react';
import '../styles/AppControlSection.css';

const AppControlSection = () => {
  return (
    <section className="app-control-section">
      <div className="background-container">
        <div className="background-image-section">
          <img 
            src="/images/page16plus/background1.jpg" 
            alt="App Control Background 1" 
            className="background-image"
          />
        </div>
        <div className="background-image-section">
          <img 
            src="/images/page16plus/background2.png" 
            alt="App Control Background 2" 
            className="background-image"
          />
        </div>
        <div className="background-image-section">
          <img 
            src="/images/page16plus/background3.png" 
            alt="App Control Background 3" 
            className="background-image"
          />
        </div>
        <div className="background-image-section">
          <img 
            src="/images/page16plus/background4.png" 
            alt="App Control Background 4" 
            className="background-image"
          />
        </div>
        <div className="background-image-section">
          <img 
            src="/images/page16plus/background5.png" 
            alt="App Control Background 5" 
            className="background-image"
          />
        </div>
      </div>
    </section>
  );
};

export default AppControlSection; 